/**
 * eslint-disable max-len
 *
 * @format
 */

import React, { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { showNotification } from "@mantine/notifications";
import { Grid, Skeleton } from "@mantine/core";
import { loadingStates } from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import {
  customChartData,
  customChartDataForLocation,
} from "../../utilities/utilities";
import DoughnutChart from "../doughnutChart/doughnutChart";

ChartJS.register(ArcElement, Tooltip, Legend);

const AgreementAnalytics = ({configs}) => {
  
   const chartOptions1 = {
     responsive: true,
     maintainAspectRatio: false,
     plugins: {
       legend: {
         position: "right",
         labels: {
           boxHeight: 10,
           boxWidth: 10,
         },
       },
     },
   };
  

  return (
    <div className="w-full">
      <Grid>
        {configs.loading === loadingStates.LOADING && (
          <>
            <Grid.Col span={4}>
              <Skeleton style={{ height: "310px" }} className="mx-8" visible />
            </Grid.Col>
            <Grid.Col span={4}>
              <Skeleton style={{ height: "310px" }} className="mx-8" visible />
            </Grid.Col>
            <Grid.Col span={4}>
              <Skeleton style={{ height: "310px" }} className="mx-8" visible />
            </Grid.Col>
            <Grid.Col span={6}>
              <Skeleton style={{ height: "310px" }} className="mx-8" visible />
            </Grid.Col>
            <Grid.Col span={6}>
              <Skeleton style={{ height: "310px" }} className="mx-8" visible />
            </Grid.Col>
          </>
        )}
        {configs.loading !== loadingStates.LOADING &&
          configs.data.agreementsStatusWise && (
            <>
              <Grid.Col span={4}>
                <div
                  className="border-2 border-none rounded-lg p-4"
                  style={{
                    boxShadow: "0px 7px 29px 0px rgba(100, 100, 111, 0.1) ",
                  }}
                >
                  <div>Status</div>
                  <div
                    style={{
                      height: "200px",
                      width: "100%",
                      padding: "16px",
                      position: "relative",
                    }}
                  >
                    <DoughnutChart
                      chartOptions={chartOptions1}
                      method={customChartData("status")}
                      data={configs?.data?.agreementsStatusWise}
                    />
                  </div>
                </div>
              </Grid.Col>
             
              <Grid.Col span={4}>
                <div
                  className="border-2 border-none rounded-lg p-4"
                  style={{
                    boxShadow: "0px 7px 29px 0px rgba(100, 100, 111, 0.1) ",
                  }}
                >
                  <div>Category</div>
                  <div
                    style={{
                      height: "200px",
                      width: "100%",
                      padding: "16px",
                      position: "relative",
                    }}
                  >
                    <DoughnutChart
                      chartOptions={chartOptions1}
                      method={customChartData("typeOfAgreement")}
                      data={configs?.data?.agreementTypeWise}
                    />
                  </div>
                </div>
              </Grid.Col>
              <Grid.Col span={4}>
                <div
                  className="border-2 border-none rounded-lg p-4"
                  style={{
                    boxShadow: "0px 7px 29px 0px rgba(100, 100, 111, 0.1) ",
                  }}
                >
                  <div>Location</div>
                  <div
                    style={{
                      height: "200px",
                      width: "100%",
                      padding: "16px",
                      position: "relative",
                    }}
                  >
                    <DoughnutChart
                      chartOptions={chartOptions1}
                      method={customChartDataForLocation("location")}
                      data={configs?.data?.agreementsLocationWise }
                    />
                  </div>
                </div>
              </Grid.Col>
            </>
          )}
      </Grid>
    </div>
  );
};

export default AgreementAnalytics;
